import { CalloutBlockType } from './types'
import { BlocksRenderer, type BlocksContent } from '@strapi/blocks-react-renderer'

interface CalloutBlockProps {
  block: CalloutBlockType
}

type Variant = 'info' | 'note' | 'warning' | 'success'

const variantStyles: Record<Variant, string> = {
  info: 'bg-blue-50 border-blue-500 text-blue-950',
  note: 'bg-muted border-border text-foreground',
  warning: 'bg-amber-50 border-amber-500 text-amber-950',
  success: 'bg-emerald-50 border-emerald-500 text-emerald-950',
}

const isKnownVariant = (variant?: string): variant is Variant =>
  variant === 'info' || variant === 'note' || variant === 'warning' || variant === 'success'

export const CalloutBlock = ({ block }: CalloutBlockProps) => {
  if (!block.body) return null

  const normalizedVariant = block.variant?.trim()
  const variant = isKnownVariant(normalizedVariant) ? normalizedVariant : 'info'

  return (
    <section className={`rounded-lg border-l-4 px-4 py-3 space-y-1 ${variantStyles[variant]}`}>
      {block.Title && <p className="font-semibold leading-snug">{block.Title}</p>}

      <div className="text-sm leading-6 [&_p]:m-0 [&_p+p]:mt-2 [&_a]:underline [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5">
        <BlocksRenderer content={block.body as unknown as BlocksContent} />
      </div>
    </section>
  )
}

export default CalloutBlock
